import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/34/thumb-landscape.jpg"

const Post34 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">CELINE／スモールバーティカルカバ／28 x31 x8cm</span>   
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>2019年に登場して以来、人気沸騰の「トリオンフ キャンバス」シリーズ。セリーヌの新しいアイコンとなる勢いです。バリエーション豊富なデザインの中から、一部をご紹介します。</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">        
        <div className="text-max-width">
          <h2>「トリオンフ キャンバス」とは</h2>
          <figure>
            <StaticImage src="../../images/posts/34/1.jpg" alt="" />
            <span className="text-center">陰影のあるプリントがビンテージライクな印象</span>
          </figure>          
          <p>2019年からセリーヌのデザイナーに就任したエディ・スリマンが、ブランドのアーカイブを再解釈して生まれた「トリオンフ キャンバス」。ブランドのエンブレムである「トリオンフ」が全面にプリントされています。<br></br>軽量で耐久性に優れたコーティングキャンバス素材を使用しており、総柄プリントから漂うヴィンテージ感が魅力のシリーズです。</p>
        </div>        
        <div className="text-max-width">
          <h2>ロゴ入りの2WAYタイプ</h2>
          <figure className="img-small">
            <StaticImage src="../../images/posts/34/2.png" alt="" />
            <span className="text-center">目を引く新しいブランドロゴとのコントラストが新鮮</span>
          </figure>
          <p>タブレットやA4サイズの書類も入る万能サイズ。上品に持つならハンドルで、カジュアルにならショルダーストラップでと、さまざまなコーデで活躍します。</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/34/3.png" alt="" />
            <span className="text-center">CELINE／スモールバーティカルカバ／28 x31 x8cm</span>   
          </figure>
        </div>
        <Link to="https://laxus.co/app/pc/bags/celine" className="view-all-button">
          セリーヌのバッグを見る
        </Link>
        <div className="text-max-width">
          <h2>カジュアル派にはショルダーバッグ</h2>
          <figure className="img-small">
            <StaticImage src="../../images/posts/34/4.png" alt="" />
            <span className="text-center">必需品をコンパクトにまとめてお出かけ</span>
          </figure>
          <p>いつものお買い物や公園など、日常の外出にもオシャレ心を。リラックスしたスタイルにもセリーヌをプラスすれば、テンションもアップ♡</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/34/5.png" alt="" />
            <span className="text-center">CELINE／フォルコ／18 x14 x6cm</span>   
          </figure>
        </div>
        <div className="text-max-width">
          <h2>お仕事バッグには容量がほしい！</h2>
          <figure className="img-small">
            <StaticImage src="../../images/posts/34/6.png" alt="" />
            <span className="text-center">チェックなどの柄物を合わせても違和感なし！</span>
          </figure>
          <p>肩にかけられる長めのハンドルや荷物を整理しやすいマチ幅など、通勤バッグに最適なタイプ。毎日バッグを変えるのは大変だから、どんなファッションにでも似合うデザインが重宝します。</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/34/7.png" alt="" />
            <span className="text-center">CELINE／ミディアムショッピング／32 x31 x18cm</span>   
          </figure>
        </div>
        <div className="text-max-width">
          <h2>個性のあるスタイルには巾着型を</h2>
          <figure className="img-small">
            <StaticImage src="../../images/posts/34/8.png" alt="" />
          </figure>
          <p>おしゃれな人の支持率が高い巾着型は、個性的なスタイルに仕上げてみては？バッグが主張しすぎることもなく、いい感じにまとまります。</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/34/9.png" alt="" />
            <span className="text-center">CELINE／スモールドローストリングバッグ／15 x21 x15cm</span>   
          </figure>
        </div>        
        <div className="text-two-cloumn">
          <h2>「知る人ぞ知る」のが<br className="pc"></br>セリーヌの魅力</h2>
          <p>セリーヌはおしゃれな人の支持率が高いブランドです。今回の「トリオンフ」柄は、有名人やスタイリストさんなどファッションのプロにも愛用者が多い注目シリーズになります。<br></br>一般的には知られていないけど、おしゃれなあの人は知っている…そんな「知る人ぞ知る」感がセリーヌの魅力かもしれません。</p>
        </div>
        <Link to="https://laxus.co/app/pc/bags/celine" className="view-all-button">
          セリーヌのバッグを見る
        </Link>        
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post34

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 34}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
